import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Colors from '../../infrastructure/constants/Colors';
import GenericModal from '../../ui/GenericModal';
import { ISkippedFile } from './graphql/useDeleteRawFiles';

interface IProps {
  open: boolean;
  files: ISkippedFile[];
  handleClose: () => void;
}

const SkippedFilesModal: React.FC<IProps> = ({ open, files, handleClose }) => {
  const { t } = useTranslation();

  return (
    <GenericModal open={open} onClose={handleClose}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h5" component="h2">
          {t('study.skippedModal.title')}
        </Typography>
        <Typography sx={{ mt: 1, color: Colors.textSecondary }} variant="body2">
          {t('study.skippedModal.description')}
        </Typography>
        <List sx={{ maxHeight: 300, overflow: 'auto', textAlign: 'left' }}>
          {files.map((file) => (
            <ListItem key={file.id} divider>
              <ListItemText primary={file.name} secondary={file.reason} />
            </ListItem>
          ))}
        </List>
        <Box display="flex" justifyContent="center" mt={2}>
          <LoadingButton onClick={handleClose} variant="contained">
            {t('button.close')}
          </LoadingButton>
        </Box>
      </Box>
    </GenericModal>
  );
};

export default SkippedFilesModal;
